<ng-container *ngIf="{
    row: columnData | async
  } as $">
  <!-- {{$.row | json}} -->
  <p-popover #op styleClass="overflow-hidden text-sm">
    <ng-template #content>
      <div *ngIf="$.row && $.row?.clt_full_name===undefined; else report">
        <!-- Dropdown Content -->
        <div class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2">
          <div class="w-10rem line-height-1">
            <div class="text-sm font-medium text-800">{{ $.row.full_name}}</div>
            <div class="text-xs text-600 mt-1">{{ $.row.id }}</div>
          </div>
          <div class="mt-1" [innerHTML]="clientStatus($.row)"></div>
        </div>
        <!-- Dropdown Content -->

        <!-- Dropdown Footer -->
        <div class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs" *ngIf="$.row">
          <div class="flex align-items-center mb-2">
            <i class="fa fa-phone mr-2 text-500"></i>
            <span *ngIf="$.row.mobile_number !== 0">{{ $.row.mobile_country_code }}{{ $.row.mobile_number }}</span>
            <span *ngIf="$.row.mobile_number === 0">NA</span>
          </div>
          <div class="flex align-items-center mb-1">
            <i class=" fa fa-envelope font-light mr-2 text-500"></i>
            <span *ngIf="$.row.email_id"> {{ $.row.email_id }}</span>
            <span *ngIf="!$.row.email_id">NA</span>
          </div>
        </div>
        <!-- Dropdown Footer -->
      </div>
    </ng-template>
  </p-popover>

  <div *ngIf="$.row && $.row?.clt_full_name===undefined; else report_button" class="flex align-items-center" (click)="op.toggle($event)">
    <span class="cursor-pointer flex align-items-center" (mouseenter)="$.row.full_name ? op.show($event) : null"
      (mouseleave)="op.hide()" (click)="executeAction('showProfile', $.row); op.toggle($event)">
      <p-avatar *ngIf="!$.row.image && $.row.full_name; else elseBlock"
        [label]="$.row.full_name | titlecase | shortName" shape="circle" styleClass="text-sm"></p-avatar>
      <ng-template #elseBlock>
        <p-avatar [image]="$.row.image" shape="circle"></p-avatar>
        <span *ngIf="!$.row.full_name">-</span>
      </ng-template>

      <strong class="ml-2 text-primary">{{ $.row.full_name }}</strong>
    </span>
  </div>

  <ng-template #report_button>
    <div class="flex align-items-center" (click)="op.toggle($event)">
      <span class="cursor-pointer flex align-items-center" (mouseenter)="$.row?.clt_full_name ? op.show($event) : null"
        (mouseleave)="op.hide()" (click)="executeAction('showProfile', $.row); op.toggle($event)">
        <p-avatar *ngIf="isEmptyAndNull($.row.clt_image) && !isEmptyAndNull($.row.clt_full_name) ; else elseBlock"
          [label]="$.row?.clt_full_name | titlecase | shortName" shape="circle" styleClass="text-sm"></p-avatar>
        <ng-template #elseBlock>
          <p-avatar [image]="$.row.clt_image" shape="circle"></p-avatar>
          <span *ngIf="!$.row?.clt_full_name">-</span>
        </ng-template>

        <strong class="ml-2 text-primary">{{ $.row?.clt_full_name }}</strong>
      </span>
    </div>

    </ng-template>


  <ng-template #report>
    <!-- Dropdown Content -->
    <div class="surface-0 -mx-4 -mt-4 flex align-items-start justify-content-between px-3 py-2">
      <div class="w-10rem line-height-1">
        <div class="text-sm font-medium text-800"> {{$.row?.clt_full_name}}</div>
        <div class="text-xs text-600 mt-1" *ngIf="$.row?.client_id || $.row?.clt_id"> {{ $.row?.client_id?$.row?.client_id:$.row?.clt_id?$.row?.clt_id:''}}</div>
      </div>
      <div class="mt-1" [innerHTML]="clientStatusOther($.row)"></div>
    </div>
    <!-- Dropdown Content -->

    <!-- Dropdown Footer -->
    <div class="px-3 py-2 -mx-4 -mb-4 surface-200 text-800 text-xs" *ngIf="$.row">
      <div class="flex align-items-center mb-2">
        <i class="fa fa-phone mr-2 text-500"></i>
        <span *ngIf="$.row?.clt_mobile_no !== 0">{{ $.row?.mobile_country_code }}{{ $.row?.clt_mobile_no?$.row?.clt_mobile_no:'' }}</span>

      </div>
      <div class="flex align-items-center mb-1">
        <i class=" fa fa-envelope font-light mr-2 text-500"></i>
        <span *ngIf="$.row?.clt_emailid"> {{ $.row.clt_emailid }}</span>
        <span *ngIf="!$.row?.clt_emailid">NA</span>
      </div>
    </div>
    <!-- Dropdown Footer -->
  </ng-template>
</ng-container>


